import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getInteraction = async (userId: string | number) => {
  return await axiosInstance.post(
    `${API_END_POINT.DELIVERY}/v1/communications/save/call-interaction?userId=${userId}`
  )
}

export const getInteractionTransitionState = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.DELIVERY}/v1/communications/interaction-status`
  )
}
